import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {SimplePresentation, SimplePresentationRunner} from "../../../core/presentation/SimplePresentationRunner";
import {FSIntroPresentation} from "../simple/FSIntroPresentation";
import {FSOutroPresentation} from "../simple/FSOutroPresentation";
import {WinExplodePresentation} from "../simple/WinExplodePresentation";
import {WinHighlightPresentation} from "../simple/WinHighlightPresentation";
import {TotalWinPresentation} from "../simple/TotalWinPresentation";
import {WinCapPresentation} from "../simple/WinCapPresentation";
import {TopReelFeaturePresentation} from "../simple/TopReelFeaturePresentation";
import {SideReelFeaturePresentation} from "../simple/SideReelFeaturePresentation";
import {BigWinPresentation} from "../BigWinPresentation";
import {TopReelDeadPresentation} from "../TopReelDeadPresentation";
import {ScatterWinPresentation} from "../ScatterWinPresentation";
import {BufferTimePresentation} from "../BufferTimePresentation";
import {PreBigWinPresentation} from "../PreBigWinPresentation";
import {PickClickResetPresentation} from "../simple/PickClickResetPresentation";

export class CommonWinPresentation implements FlowStatePresentation {
    private readonly _presentations: SimplePresentation[];
    private _flowStateController: FlowStateController;

    constructor() {
        this._presentations = [
            new SideReelFeaturePresentation(),
            new WinHighlightPresentation(),
            new WinExplodePresentation(),
            new PreBigWinPresentation(),
            new BigWinPresentation(),
            new TopReelDeadPresentation(),
            new TopReelFeaturePresentation(),
            new TotalWinPresentation(),
            new PickClickResetPresentation(),
            new ScatterWinPresentation(),
            new FSIntroPresentation(),
            new FSOutroPresentation(),
            new WinCapPresentation(),
            new BufferTimePresentation()
        ];
    }

    public start(flowStateController: FlowStateController): void {
        this._flowStateController = flowStateController;
        SimplePresentationRunner.run(this._presentations, (): void => {
            this.complete();
        }, (callback?: Function): void => {
            flowStateController.setSkipCallback(callback);
        });
    }

    private complete(): void {
        this._flowStateController.finish();
    }
}